import Button from '../Button/index';

const SubmitButton = Button.withComponent('button');
SubmitButton.defaultProps = {
  variant: 'primary',
};

export default SubmitButton;
